export default __webpack_public_path__ + "static/media/transforming-pop-label.228536a5.svg";